import { Controller } from "@hotwired/stimulus"

// Simple controller to scroll to the top of the page when clicked
// Connects to data-controller="scroll-to-top"
export default class extends Controller {
  scroll(event) {
    event.preventDefault()
    window.scrollTo(0, 0)
  }
}
